module.exports = __webpack_public_path__ + "static/img/logo13.b4d04984.png";